import { render, staticRenderFns } from "./DocImplantar.vue?vue&type=template&id=397672eb&scoped=true&lang=pug&"
import script from "./DocImplantar.vue?vue&type=script&lang=js&"
export * from "./DocImplantar.vue?vue&type=script&lang=js&"
import style0 from "./DocImplantar.vue?vue&type=style&index=0&id=397672eb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397672eb",
  null
  
)

export default component.exports